<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Button, Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../../public/my-theme";
  import type { Fn } from "../../../../global";
  import type { Complainant } from "../../../../Model/Complainant";
  import type { ComplainantTraffic } from "../../../../Model/ComplainantTraffic";
  import type { Third } from "../../../../Model/Third";
  import { complainantService, complainantTrafficService, thirdLicenseService, thirdsService } from "../../../../services";
  import AddVehicleList from "../../../AddVehicleList.svelte";
  import DateLocalInput from "../../../DateLocalInput.svelte";
  import ParamSelect from "../../../ParamSelect.svelte";
  import SignCanvas from "../../../SignCanvas.svelte";
  import VehicleInput from "../../../VehicleInput.svelte";
  import ComplaintInfoForm from "../../ComplaintInfoForm.svelte";
  import { dateInputFormatter } from "../../../../services/Functions";
  import { select_value } from "svelte/internal";
  import { ThirdLicense } from "../../../../Model/ThirdLicense";
  import ThirdLicenseModal from "../../../ThirdLicenseModal.svelte";
  import { v4 as uuidv4 } from "uuid";
    import ThirdLicensesList from "../../../ThirdLicensesList.svelte";

  export let complainantThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, complainantThird)

  let size = "lg";
  let editVehicle: boolean = false;
  let complainant: Complainant;
  let complainantTraffic: ComplainantTraffic;
  let licenseExpiration: string;
  let third: Third;
  let licenses: ThirdLicense[];

  const dispatch = createEventDispatcher();

  async function load(diligenceId, complainantThird){
    if (diligenceId && complainantThird) {

      /* let complainants: Complainant[] = await complainantService.findByDiligenceNumber(diligenceId)
      complainant = complainants.find(c => c.complainantThirId == complainantThird.id) */

      complainant = await complainantService.findOne(complainantThird.id, diligenceId);
      third = await thirdsService.findOne(complainantThird.id);

      if (complainant) {

        complainantTraffic = await complainantTrafficService.findOne(complainantThird.id, complainant.diligenceNumber);
        /* if(third.has_license) {
          licenses = await thirdLicenseService.getThirdLicensByThirdId(third.id);

          for(const license of licenses) {
            license.exp_date = dateInputFormatter(license.exp_date) as string;
          }
        } */
        /* if(complainantTraffic.license_expiration) {
          licenseExpiration = dateInputFormatter(complainantTraffic.license_expiration);
          console.log(licenseExpiration)
        } */

      }

    }
  }

  async function saveComplainantTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    complainant.complainantThirId = third.id;
    complainantTraffic.complainantThirId = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      complainantService.saveComplainant(complainant),
      complainantTrafficService.saveComplainantTraffic(complainantTraffic),
      thirdsService.saveThird(third)
    ])

    dispatch('saveComplainant');
  }

  async function changeVehicleEvent(vehicleId) {
    complainantTraffic.vehicle_id = vehicleId;
    editVehicle = false
    save();
  }

  async function addSigntToActivity(event) {}

  function changeThirdLicense(event: any) {
    third.has_license = event.srcElement.value == 1 ? true : false;
    third = third;
  }
</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <TabContent>
      <TabPane tabId="Datos" tab="Datos" active>
        {#if complainant}
          <ComplaintInfoForm complainant={complainant} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      </TabPane>
      {#if complainantTraffic}
        <TabPane tabId="dataVehicle" tab="Datos del Vehículo">
          <div class="row mt-3">
            <div class="col-12">
              <h5>Datos del conductor</h5>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <Label>Permiso de conducir</Label>
              <Input
                type="select"
                id="wantToDeclare"
                value={third.has_license ? 1 : 0}
                on:change={(event) => {changeThirdLicense(event)}}
              >
                <option value={1}>Si</option>
                <option value={0}>No</option>
              </Input>
            </div>
            {#if third.has_license }
              <div class='p-4'>
                <ThirdLicensesList thirdId={third.id} userModal={false} />
              </div>
            {/if}
          </div>
          <hr>
          <div class="row">
            <div class="col-12 mb-3 mt-2">
              <Label for="matricula">Matricula</Label>
              <div class="input-group">
                <VehicleInput id={complainantTraffic?.vehicle_id} />
                <button
                  class="btn btn-secondary"
                  type="button"
                  id="complainantThirId"
                  name="complainantThirId"
                  on:click={() => { editVehicle = true; }}>
                  <Icon name="plus" />
                </button>
              </div>
            </div>

            {#if editVehicle}
              <AddVehicleList on:changeVehicle={(event) => changeVehicleEvent(event.detail)} />
            {/if}

            <div class="col-12 mb-3">
              <Label for="danios">Daños Vehiculo</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={complainantTraffic.vehicle_damage}
              />
            </div>
            <div class="col-12 col-sm-3">
              <Label>Matrícula Remolque</Label>
              <Input type="text" bind:value={complainantTraffic.trailer_registration} />
            </div>
            <!-- <div class="col-3 ">
              <Label>Permiso de conducir</Label>
              <Input
                type="select"
                id="wantToDeclare"
                value={complainantTraffic.driving_license ? 1 : 0}
                on:change={(event) => {
                  complainantTraffic.driving_license = Boolean(
                    select_value(event.target)
                  );
                }}>
                <option value={1}>Si</option>
                <option value={0}>No</option>
              </Input>
            </div>
            <div class="col-6">
              <Label>Periodo de validez</Label>
              <Input
                  type="date"
                  on:change={() => {complainantTraffic.license_expiration = new Date(licenseExpiration); console.log(licenseExpiration)}}
                  bind:value={licenseExpiration}
                />
            </div> -->
          </div>

        </TabPane>
        <TabPane tabId="dataInfo1" tab="Alcoholemia">
          <div class="row mt-2">
            <div class="col-12 mb-2">
              <Label>Prueba alcoholemia</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.perform_alcoholemia} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Hora - Toma 1</Label>
              <DateLocalInput bind:value={complainantTraffic.time_p_alcohol1}/>
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Resultado - Toma 1</Label>
              <Input type="text" bind:value={complainantTraffic.result_p_alcohol1} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Hora - Toma 2</Label>
              <DateLocalInput bind:value={complainantTraffic.time_p_alcohol2}/>
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Resultado - Toma 2</Label>
              <Input type="text" bind:value={complainantTraffic.result_p_alcohol2} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Excede 60</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.exceeds_060} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Extracción de sangre</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.urine_blood_extraction} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Bajo influencia</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.low_influence} />
            </div>
          </div>
        </TabPane>
        <TabPane tabId="dataInfo2" tab="Inf.Médico">
          <div class="row mt-2">
            <div class="col-12 col-sm-3 mb-2">
              <Label>Examen medico</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.medical_examination} />
            </div>
            <div class="col-12 mb-2">
              <Label>Historial Médico</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={complainantTraffic.medical_history}
              />
            </div>
            <div class="col-12 mb-2">
              <Label>Parte Facultativo</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={complainantTraffic.optional_part}
              />
            </div>
          </div>
        </TabPane>
        <TabPane tabId="dataInfo3" tab="Fisionomía">
          <div class="row mt-2">
            <div class="col-12 col-sm-6 mb-2">
              <Label>Defectos físicos</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.physical_defects} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Pupilas</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.pupils_id} paramType="pupils" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Rostro</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.ask_react_id} paramType="rostro" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Comportamiento</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.behavior_id} paramType="behavior" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Vestimenta</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.dress_id} paramType="dress" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Aspecto</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.ask_react_id} paramType="rostro" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Facciones</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.ask_react_id} paramType="rostro" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Mirada</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.look_id} paramType="look" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Movimientos</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.movements_id} paramType="movements" nothing={true} />
            </div>

            <div class="col-12 col-sm-6 mb-2">
              <Label>Otros Detalles</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.others_detalles_id} paramType="others_details" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Constitución Física</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.physical_constitution_id} paramType="physical_constitution" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Respiración</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.respiration_id} paramType="respiration" nothing={true} />
            </div>
            <div class="col-12 col-sm-6 mb-2">
              <Label>Voz</Label>
              <ParamSelect bind:paramSelectId={complainantTraffic.voice_id} paramType="voice" nothing={true} />
            </div>

          </div>
        </TabPane>
        <TabPane tabId="dataDriver1" tab="Abogacia">
          <div class="row mt-2">
            <div class="col-12 col-sm-3 mb-2">
              <Label>Informe administrativo</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.administrative_infection} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Abogado</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.appoints_lawyer} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>De oficio</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.ex_officio} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Aviso familiar</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.family_notice} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Intérprete</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.interpreter} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Quiere declarar</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.want_declare} />
            </div>
            <div class="col-12 col-sm-3 mb-2">
              <Label>Quiere Denunciar</Label>
              <Input type="checkbox" label="Si" bind:checked={complainantTraffic.complaint} />
            </div>
            <div class="col-12">
              <Label>Boletin</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={complainantTraffic.num_boletin}
              />
            </div>
          </div>
        </TabPane>
        <TabPane tabId='singData' tab='Firma'>
          <SignCanvas on:savePngSign={(event) => addSigntToActivity(event.detail)} />
        </TabPane>
      {/if}

    </TabContent>
    <!-- <DiligenceComplainantTrafficData complainantTraffic={complainantTraffic} diligenceId={diligenceId} /> -->

  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveComplainantTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

